var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard41(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_41);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #656fb2;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_41",
    "data-name": "Artboard \\u2013 41",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2492",
    "data-name": "Group 2492",
    transform: "translate(-10920.811 -6737.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    className: "cls-2",
    d: "M432.4,69.067a2.238,2.238,0,0,0-3.668-.706q-2.721,2.707-5.428,5.428a5.768,5.768,0,0,0-1.733,4.063.749.749,0,0,0,.824.835,5.715,5.715,0,0,0,4.066-1.719q2.729-2.712,5.443-5.44a2.244,2.244,0,0,0,.607-1.073c.012-.048,0-.115.065-.142V69.6C432.52,69.424,432.474,69.24,432.4,69.067Zm-1.537,1.383c-.5.517-1.018,1.023-1.528,1.534q-1.947,1.947-3.893,3.894a4.408,4.408,0,0,1-2.2,1.222c-.023,0-.047.006-.1.012a4.112,4.112,0,0,1,1.1-2.145q2.766-2.791,5.554-5.56a.74.74,0,0,1,1.056-.012A.732.732,0,0,1,430.865,70.45Z",
    transform: "translate(10518.567 6681.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    className: "cls-2",
    d: "M420.267,79.157a.746.746,0,0,0-.733.706c-.01.249,0,.5,0,.747a10.27,10.27,0,0,1-.021,1.231,2.214,2.214,0,0,1-2.281,1.978q-3.875,0-7.752,0a.948.948,0,0,0-.677.256c-.371.341-.752.671-1.125,1.011a.755.755,0,0,1-1.3-.58q0-4.445,0-8.891a2.124,2.124,0,0,1,.056-.5,2.248,2.248,0,0,1,2.255-1.755q2.783,0,5.567,0c.225,0,.449,0,.673,0a.726.726,0,0,0,.682-.562.749.749,0,0,0-.786-.928q-3.092,0-6.183,0a3.613,3.613,0,0,0-.815.089,3.731,3.731,0,0,0-2.942,3.69q0,2.2,0,4.39c0,1.513-.012,3.026,0,4.539a2.239,2.239,0,0,0,3.653,1.728c.341-.27.657-.572.977-.867a.426.426,0,0,1,.315-.122q3.661.006,7.322,0a5.255,5.255,0,0,0,.689-.038,3.743,3.743,0,0,0,3.145-3.215,19.312,19.312,0,0,0,.028-2.221A.728.728,0,0,0,420.267,79.157Z",
    transform: "translate(10527.13 6679.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    className: "cls-2",
    d: "M415.109,81.069q-1.514-.009-3.028,0c-.6,0-1.054.332-1.054.749s.447.738,1.055.743c.5,0,1.009,0,1.514,0s1.009,0,1.514,0c.606,0,1.054-.324,1.053-.744S415.713,81.072,415.109,81.069Z",
    transform: "translate(10523.978 6674.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    className: "cls-2",
    d: "M411.791,87.206A.746.746,0,1,0,411.8,88.7c.367,0,.734,0,1.1,0s.722,0,1.083,0a.747.747,0,1,0,.012-1.492Q412.892,87.2,411.791,87.206Z",
    transform: "translate(10523.978 6671.364)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34-2",
    "data-name": "Ellipse 34-2",
    className: "cls-3",
    cx: 7.6,
    cy: 7.6,
    r: 7.6,
    transform: "translate(10925.476 6743.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    className: "cls-2",
    d: "M246.187,72.537h-2.395V70.142a.627.627,0,0,0-.6-.6h-.6a.627.627,0,0,0-.6.6v2.395H239.6a.627.627,0,0,0-.6.6v.6a.627.627,0,0,0,.6.6H242v2.395a.627.627,0,0,0,.6.6h.6a.627.627,0,0,0,.6-.6V74.333h2.395a.627.627,0,0,0,.6-.6v-.6A.627.627,0,0,0,246.187,72.537Z",
    transform: "translate(10690.581 6677.84)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard41);
export default __webpack_public_path__ + "static/media/Artboard – 41.de4ca7f118bc06ddd880338d6fbad3a3.svg";
export { ForwardRef as ReactComponent };